import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import Marker from './Marker';
import { googleMapAPIKey } from './../../utility/apiKeys';

export default class GMarker extends Component {
    static defaultProps = {
        coordinate: {
            lat: 59.95,
            lng: 30.33
        },
        zoom: 11
    };

    render() {
        return (
            // <div style={{ height: '94%', width: '100%' }}>
            //     <GoogleMapReact
            //         bootstrapURLKeys={{ key: googleMapAPIKey }}
            //         center={[this.props.lat , this.props.lon]} 
            //         zoom={14}
            //     >
            //         <Marker
            //             lat={this.props.lat}
            //             lng={this.props.lon}
            //             text="My Marker"
            //         />
            //     </GoogleMapReact>
            // </div>
            <iframe

                frameborder="0" style={{ height: '100%', width: '100%' }}
                src={`https://www.google.com/maps/embed/v1/place?key=${googleMapAPIKey}&q=${this.props.lat},${this.props.lon}`} allowfullscreen>
            </iframe>
        );
    }
}